// router/routes.js
import HomeView from '@/views/HomeView.vue'
import CasesView from '@/views/CasesView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

export const routes = [
	{ path: '/', name: 'Home', component: HomeView },
	{ path: '/cases', name: 'Cases', component: CasesView },
	{ path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
]
